import client from "./Client";

const getAdminData = () => {
  return client.get('/details');
};

const getDashboardStats = () => {
  return client.get('/dashboard-stats');
};

const getTopSchoolsByActiveStudents = () => {
  return client.get('/top-schools/active-students');
};

const getRecentlyRegisteredSchools = () => {
  return client.get('/recently-registered-schools');
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAdminData,
  getDashboardStats,
  getTopSchoolsByActiveStudents,
  getRecentlyRegisteredSchools
};
